import * as React from "react";
function SvgHashtag(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M44.5 17.2c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7h-9.8l1.9-10.4c.2-.9-.5-1.9-1.4-2-.9-.2-1.9.5-2 1.4l-2 11h-12l2.2-11.7c.2-.9-.5-1.9-1.4-2-.9-.2-1.9.5-2 1.4l-2.2 12.3H5.1c-.9 0-1.7.8-1.7 1.7 0 .9.8 1.7 1.7 1.7h10L13 28.9H3.5c-.9 0-1.7.8-1.7 1.7 0 .9.8 1.7 1.7 1.7h8.8L10 44.8c-.2.9.4 1.8 1.4 2h.3c.8 0 1.6-.6 1.7-1.4l2.4-13.1h12L25.3 46c-.2.9.4 1.8 1.4 2h.3c.8 0 1.6-.6 1.7-1.4l2.5-14.3h11.7c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7h-11L34 17.2h10.5zM28.4 28.9h-12l2.2-11.7h12l-2.2 11.7z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgHashtag);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
